export default {"src":"/_next/static/media/tilda-logo.7484e61c.svg","height":160,"width":624,"blurWidth":0,"blurHeight":0};